module.exports = __webpack_public_path__ + "img/article_ad_banner_01.1997adb4.png";